import {
  LeftJustifiedInsuranceTermsLink,
  LeftJustifiedIpidLinks,
} from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.styles";
import React, { useState } from "react";

import CollapsibleContainer from "Components/CollapsibleContainer";
import { CoverageInfo } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/productPriceTile.styles";
import { ThemedButton } from "Components/Themes/components/ThemedButton";
import { ProductCoverageContainer } from "Features/CheckPrice/Products/Advice/adviceStyled";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import { AdviceCoverageName } from "Store/akaAdvice/interfaces/AkaAdviceState";
import { buttonTrackId } from "Utils/analytics";
import { useWindowSize } from "Utils/screenSizeUtils";
import { MarginLeftWrapper } from "../styled";
import { AkaCriticalIllnessCoverageInfo } from "./AkaCriticalIllnessCoverageInfo";
import { AkaGroupLifeCoverageInfo } from "./AkaGroupLifeCoverageInfo";

interface Props {
  backendInsuranceName: ProductBackendName;
  coverageGroup: AdviceCoverageName;
}

export const AkaAdviceProductCoverages = ({
  backendInsuranceName,
  coverageGroup,
}: Props): React.ReactElement | null => {
  const windowSize = useWindowSize();
  const mobileVariant = windowSize.width ? windowSize.width < 540 : false;

  const [showDetails, toggleDetails] = useState(false);
  const handleToggleDetails = (): void => {
    toggleDetails(!showDetails);
  };

  return (
    <MarginLeftWrapper>
      <CoverageInfo>
        <ThemedButton
          variant="text"
          trackId={buttonTrackId("See terms and details")}
          onClick={handleToggleDetails}
          iconRight={showDetails ? "chevron-up" : "chevron-down"}
        >
          <p>{"Se betingelser og detaljer"}</p>
        </ThemedButton>
      </CoverageInfo>
      <CollapsibleContainer isOpen={showDetails}>
        <ProductCoverageContainer>
          <AkaGroupLifeCoverageInfo coverageGroup={coverageGroup} />
          <AkaCriticalIllnessCoverageInfo coverageGroup={coverageGroup} />
          <LeftJustifiedIpidLinks
            coverage={coverageGroup}
            useShortText={mobileVariant}
          />
          <LeftJustifiedInsuranceTermsLink
            coverage={coverageGroup}
            productBackendName={backendInsuranceName}
          />
        </ProductCoverageContainer>
      </CollapsibleContainer>
    </MarginLeftWrapper>
  );
};
